
import BaseContentForm from "./BaseContentForm";
import { useContentData } from "@/hooks/useContentData";

interface EditContentFormProps {
  contentId: string;
  initialData?: {
    title: string;
    url: string;
    description?: string;
    content_type: string;
    collection_id?: string;
  };
  onComplete?: () => void;
}

const EditContentForm = ({ 
  contentId, 
  initialData, 
  onComplete 
}: EditContentFormProps) => {
  // If initialData is provided, use it directly
  if (initialData) {
    const completeFormData = {
      id: contentId,
      ...initialData,
    };

    return (
      <BaseContentForm 
        initialData={completeFormData} 
        onComplete={onComplete} 
        isUpdate={true} 
      />
    );
  }
  
  // Fetch content data and associated collection
  const { completeFormData, isLoading } = useContentData(contentId);

  if (isLoading) {
    return (
      <div className="py-4 flex justify-center">
        <div className="animate-spin h-6 w-6 border-2 border-clustr-blue border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (!completeFormData) {
    return (
      <div className="py-4 text-center text-red-500">
        Content not found or could not be loaded.
      </div>
    );
  }

  return (
    <BaseContentForm 
      initialData={completeFormData} 
      onComplete={onComplete} 
      isUpdate={true} 
    />
  );
};

export default EditContentForm;
